import { render, staticRenderFns } from "./AssociateClientWidgetComponent.vue?vue&type=template&id=09a10684&"
import script from "./AssociateClientWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./AssociateClientWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports